import { handleResponse } from '../Helpers/handle-response';
import * as apiHelper from '../Helpers/apiHelper';

export const dataService = {
    authenticate,
    getBrokers,
    getPurchaseOrderTypes,
    getSupplierTypes,
    getSuppliers,
    getUoms,
    getTransportTypes,
    getProducts,
    getTranslations,
    getTranslationValues,
    getLanguages,
    getPriceSchemes,
    getFreeClauses,
    getDocumentTextOverview,
    getCountries,
    getPaymentTerms,
    savePurchaseOrder,
    getPurchaseOrders,
    getNumberRanges,
    increaseNumberRange,
    getCertificatesBySupplierID,
    saveCertificate,
    getSystemParameterValueBySystemParameterId
};

function authenticate(username, password) {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_LOGIN);
    url += `?username=${username}`;
    url += `&password=${password}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getBrokers() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETBROKERS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getPurchaseOrderTypes() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPURCHASEORDERTYPES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSupplierTypes() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSUPPLIERTYPES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSuppliers() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSUPPLIERS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getUoms() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETUOMS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getTransportTypes() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETTRANSPORTTYPES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProducts() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getTranslations() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETTRANSLATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getNumberRanges() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETNUMBERRANGES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getTranslationValues() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETTRANSLATIONVALUES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getLanguages() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETLANGUAGES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getPriceSchemes() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRICESCHEMES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getFreeClauses() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETFREECLAUSES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getDocumentTextOverview() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETDOCUMENTTEXTOVERVIEW);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getCountries() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETCOUNTRIES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getPaymentTerms() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPAYMENTTERMS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function savePurchaseOrder(purchaseOrder, freeClauses,purchaseOrderLines,userId) {
    
    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify({
            ID:purchaseOrder.editcontractid,
            ExternalReference: purchaseOrder.externalReference,
            ExternalReferenceID: purchaseOrder.externalReferenceID,
            ContractDate: purchaseOrder.contractDate.toLocaleString('en-US', { timeZone: "Europe/Brussels" }),
            PurchaseOrderTypeID: purchaseOrder.purchaseOrderTypeID,
            UnitOfMeasurementID: purchaseOrder.unitOfMeasurementID,
            VendorID: purchaseOrder.vendorID,
            VendorTypeID: purchaseOrder.vendorTypeID,
            TransportTypeID: purchaseOrder.transportTypeID,
            TransportPrice100Kg: purchaseOrder.transportPrice100Kg,
            PaymentTermID: purchaseOrder.paymentTermID,
            HarvestYear: purchaseOrder.harvestYear,
            BrokerID: purchaseOrder.brokerID,
            ValidUntil: purchaseOrder.validUntillDate,
            // certificateInfo: props.addPage.certificateInfo,
            UserIdInsert:userId,
            UserIdUpdate:userId,
            Remark: purchaseOrder.remark,
            PurchaseOrderLines: purchaseOrderLines,
            FreeClauses:freeClauses
        })
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEPURCHASEORDER);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getPurchaseOrders() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPURCHASEORDERS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function increaseNumberRange() {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'PUT', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_INCREASENUMBERRANGE);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getCertificatesBySupplierID(supplierID) {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            // 'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETCERTIFICATESBYSUPPLIERID);
    url += `?supplierID=${supplierID}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveCertificate(number,momentValidUntil,supplierID) {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify({
            SupplierID:supplierID,
            Number:number,
            MomentValidUntil:momentValidUntil           
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVECERTIFICATE);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSystemParameterValueBySystemParameterId(systemParameterID) {

    var token = apiHelper.ComposeAuthToken();
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSYSTEMPARAMETERVALUEBYSYSTEMPARAMETERID);
    url += `?systemParameterId=${systemParameterID}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}









